import { cn } from '@/utils/tailwind';
import { ReactNode, forwardRef } from 'react';

interface FeedbackButtonProps {
  children: ReactNode;
  onClick?: () => void;
  className?: string;
}

const FeedbackButton = forwardRef<HTMLButtonElement, FeedbackButtonProps>(
  ({ children, onClick, className }, ref) => {
    return (
      <button
        ref={ref}
        onClick={onClick}
        className={cn('rounded-[8px] bg-gr-100 px-[10px] py-[6px] text-gr-700', className)}
      >
        {children}
      </button>
    );
  },
);

FeedbackButton.displayName = 'FeedbackButton';

export default FeedbackButton;
